<template>
	<div class="sign-nav-bar">
		<div class="bar-content">
			<div class="nav-bar-title">
					<img :src="logoUri"/>
					<div class="title-name">{{title}}</div>
			</div>
			<div class="nav-list">
				<NavList :navList="navList" :routerName="routerName"></NavList>
			</div>
			<slot></slot>
			<!-- <MyProperty></MyProperty> -->
		</div>	
	</div>
</template>

<script>
import MyProperty from '@/views/navbars/MyProperty.vue'
import NavList from '@/views/navbars/NavList.vue'
export default {
	props: {
		logoUri:{
			type:String,
			default:require("@/assets/logo.png")
		},
		title:{
			type:String,
			default:"二级导航"
		},
		navList:  {
	      type: Array
	      
	    },
	    routerName:{
	      type:String
	    }
	  },
 components: {
    NavList
  },
  data(){
    return {
     activeName: 'second'
    } 
  }
}	
</script>

<style scoped lang="scss">
	*{
		-webkit-touch-callout:none;  /*系统默认菜单被禁用*/
		-webkit-user-select:none; /*webkit浏览器*/
		-khtml-user-select:none; /*早期浏览器*/
		-moz-user-select:none;/*火狐*/
		-ms-user-select:none; /*IE10*/
		user-select:none;
	}
	input{
		-webkit-user-select:auto; /*webkit浏览器*/
	}
	textarea{
		-webkit-user-select:auto; /*webkit浏览器*/
	}
	.sign-nav-bar{
		width: 100%;
		height:$nav-bar-height;
		background-color:$nav-bar-color ;
	}
	.bar-content{
		width:1180px;
		margin: 0 auto;
		position: relative;
	}
	.bar-content .title-name{
		position: absolute;
		top: 22px;
		left: 67px;
		font-size:24px;
		font-family:SourceHanSansCN-Medium,SourceHanSansCN;
		font-weight:500;
		color:rgba(39,142,96,1);
		line-height:36px;
	}
	.sign-nav-bar .bar-content .nav-bar-title img{
		width:43px;
		height:35px;
		position: absolute;
		top: 26px;
	    left: 5px;
	}
	.bar-content .nav-list{
		height: 30px;
		position: absolute;
		top: 66px;
	}
	
	
</style>